import { render, staticRenderFns } from "./PickupsList.vue?vue&type=template&id=e033b7fe&scoped=true&"
import script from "./PickupsList.vue?vue&type=script&lang=ts&"
export * from "./PickupsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e033b7fe",
  null
  
)

export default component.exports